import React from 'react';
import PropTypes from 'prop-types';

const SubmitSuccessContent = (props) => {
  const { areMcqQuestions } = props;
  const MCQ_MESSAGE =
    ' It may take a few minutes for your multiple-choice question results to become available.';

  return (
    <div className="leading-normal" aria-live="polite">
      <span>
        You have successfully submitted your assessment.
        {areMcqQuestions && MCQ_MESSAGE}
      </span>
    </div>
  );
};

SubmitSuccessContent.propTypes = {
  areMcqQuestions: PropTypes.bool,
};

SubmitSuccessContent.defaultProps = {
  areMcqQuestions: false,
};

export default SubmitSuccessContent;
